import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Trophy, ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { getCompetitionCopy } from '../i18n/competition';

const DEADLINE = new Date('2026-10-31T23:59:59Z').getTime();

const calc = () => {
  const diff = DEADLINE - Date.now();
  if (diff <= 0) return null;
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

const Unit = ({ v, l }) => (
  <span className="flex items-baseline gap-0.5">
    <span className="font-semibold tabular-nums">{String(v).padStart(2, '0')}</span>
    <span className="text-[0.6rem] opacity-70">{l}</span>
  </span>
);

const CompetitionBar = () => {
  const [t, setT] = useState(calc);
  const { pathname } = useLocation();
  const { lang } = useLang();
  const c = getCompetitionCopy(lang);

  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!t) return null;
  const onCompetition = pathname === '/competition';

  return (
    <Link
      to="/competition"
      data-testid="competition-topbar"
      className="fixed top-0 left-0 right-0 z-50 h-10 flex items-center justify-center gap-2 sm:gap-4 px-3 bg-gold text-espresso text-[0.7rem] sm:text-xs tracking-wide hover:bg-gold-light transition-colors"
    >
      <Trophy className="w-3.5 h-3.5 shrink-0" />
      <span className="uppercase tracking-[0.12em] font-medium whitespace-nowrap truncate">
        <span className="hidden md:inline">{c.bar.comp} · </span>{c.bar.win} <strong>{c.bar.winB}</strong>{c.bar.win2 ? ` ${c.bar.win2}` : ''}
      </span>
      <span className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap" data-testid="competition-countdown">
        <Unit v={t.d} l="d" /><Unit v={t.h} l="h" /><Unit v={t.m} l="m" /><span className="hidden sm:flex"><Unit v={t.s} l="s" /></span>
      </span>
      {!onCompetition && (
        <span className="hidden sm:inline-flex items-center gap-1 uppercase tracking-[0.15em] font-semibold underline underline-offset-4 decoration-espresso/40">
          {c.bar.apply} <ArrowRight className="w-3 h-3 rtl:rotate-180" />
        </span>
      )}
    </Link>
  );
};

export default CompetitionBar;
